import { render, staticRenderFns } from "./agreement-setting.vue?vue&type=template&id=22f4900c&scoped=true"
import script from "./agreement-setting.vue?vue&type=script&lang=js"
export * from "./agreement-setting.vue?vue&type=script&lang=js"
import style0 from "./agreement-setting.vue?vue&type=style&index=0&id=22f4900c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f4900c",
  null
  
)

export default component.exports